import React from 'react';
import { Column, RowData } from '@tanstack/react-table';
import { IconArrow } from 'icons';
import { Button, Text } from '@chakra-ui/react';

interface FilterProps<TData extends RowData> {
  column: Column<TData, unknown>;
  children?: React.ReactNode;
}

export const SortingHeader = <TData extends RowData>({
  column,
  children,
}: FilterProps<TData>) => {
  return (
    <Button
      variant="ghost"
      p={0}
      height="fit-content"
      onClick={column.getToggleSortingHandler()}
      title={
        column.getCanSort()
          ? column.getNextSortingOrder() === 'asc'
            ? 'Ascending'
            : column.getNextSortingOrder() === 'desc'
            ? 'Descending'
            : 'Default'
          : undefined
      }
    >
      <Text fontSize="0.75rem" lineHeight="0.75rem" fontWeight={400}>
        {children}
      </Text>
      {column.getIsSorted() === 'asc' ? (
        <IconArrow h="10px" __css={{ transform: 'rotate(270deg)' }} />
      ) : column.getIsSorted() === 'desc' ? (
        <IconArrow h="10px" __css={{ transform: 'rotate(90deg)' }} />
      ) : (
        <>
          <IconArrow h="10px" __css={{ transform: 'rotate(270deg)' }} />
        </>
      )}
    </Button>
  );
};

export const DefaultHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <Button variant="ghost" p={0} height="fit-content">
      <Text fontSize="0.75rem" lineHeight="0.75rem" fontWeight={400}>
        {children}
      </Text>
    </Button>
  );
};
